import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WchfsRippleDirective } from '../shared/ripple/ripple';
import { ButtonComponent } from './button.component';

@NgModule({
  declarations: [ButtonComponent, WchfsRippleDirective],
  imports: [CommonModule],
  exports: [ButtonComponent],
})
export class ButtonModule {}
